import React from "react"

const Success = () => {

    return(
        <div className="success-container">
      <div className="success-content">
        <h1 className="success-title">Success!</h1>
        <p className="success-message">
          Your form was submitted successfully.
        </p>
        <a><button className="success-button" onClick={() => window.location.href = '/'}>
          Go back to home
        </button></a>
      </div>
    </div>
    )
}

export default Success;